import { useStateValue } from '../contexto/store';

/**
 * useAuth — Centralized authentication hook.
 *
 * Provides access to the session state and auth actions so that
 * components are decoupled from the Context structure and localStorage.
 *
 * Usage:
 *   const { isAuthenticated, usuario, logout } = useAuth();
 */
const useAuth = () => {
  const [{ sesionUsuario }, dispatch] = useStateValue();

  const isAuthenticated = sesionUsuario?.autenticado === true;
  const usuario = sesionUsuario?.usuario ?? null;

  /**
   * Clears the JWT from localStorage, resets the global session state,
   * and navigates the user to the login page.
   */
  const logout = () => {
    window.localStorage.removeItem("token_seguridad");
    dispatch({
      type: "SALIR_SESION",
      autenticado: false,
      nuevoUsuario: null,
    });
    window.location.replace("/");
  };

  return {
    sesionUsuario,
    usuario,
    isAuthenticated,
    logout,
  };
};

export default useAuth;
